import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ContactHero from '@/app/contact/components/ContactHero';
import ContactInfoCards from '@/app/contact/components/ContactInfoCards';
import ContactForm from '@/app/contact/components/ContactForm';
import PageTransition from '@/components/PageTransition';

export default function ContactPage() {
  return (
    <main className="min-h-screen bg-background">
      <Header />
      <PageTransition>
        <ContactHero />
        <ContactInfoCards />
        <ContactForm />
        <Footer />
      </PageTransition>
    </main>
  );
}
